(() => {
  const uuidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

  document.querySelectorAll('[data-guest-reorder]').forEach((form) => {
    const fieldset = form.querySelector('fieldset');
    const submit = form.querySelector('button[type="submit"]');
    const status = form.querySelector('[data-guest-reorder-status]');
    const honeypot = form.elements.b2b_website_url;
    let idempotencyKey = crypto.randomUUID();
    let submitting = false;
    fieldset.disabled = false;

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (submitting) return;
      if (honeypot.value) {
        status.textContent = form.dataset.error;
        status.className = 'b2br-status b2br-status--error';
        status.hidden = false;
        return;
      }
      if (!form.reportValidity()) return;

      const data = new FormData(form);
      const message = [
        'Manual reorder request (not a confirmed order)',
        data.get('priorOrderReference') ? `Prior order reference: ${data.get('priorOrderReference')}` : 'First-time request; no prior order reference supplied',
        `Desired items / notes:\n${data.get('desiredItems')}`,
        data.get('requestedDate') ? `Requested date: ${data.get('requestedDate')}` : '',
        `Locale: ${data.get('locale')}`
      ].filter(Boolean).join('\n\n').slice(0, 2000);
      const payload = {
        companyName: data.get('companyName'),
        contactName: data.get('contactName'),
        email: data.get('email'),
        phone: data.get('phone') || '',
        quantity: String(data.get('quantity')),
        message,
        consentToContact: false,
        consentPurpose: data.get('consentPurpose'),
        consentVersion: data.get('consentVersion')
      };

      submitting = true;
      submit.disabled = true;
      status.textContent = form.dataset.sending;
      status.className = 'b2br-status';
      status.hidden = false;
      try {
        const response = await fetch(form.action, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Idempotency-Key': idempotencyKey
          },
          body: JSON.stringify(payload)
        });
        let result = null;
        try {
          result = await response.json();
        } catch (_) {
          result = null;
        }
        if (response.status !== 201 || !result || !uuidPattern.test(result.id)) throw new Error('invalid_response');
        status.textContent = form.dataset.success;
        status.className = 'b2br-status b2br-status--success';
        form.reset();
        fieldset.disabled = true;
        idempotencyKey = crypto.randomUUID();
      } catch (_) {
        status.textContent = form.dataset.error;
        status.className = 'b2br-status b2br-status--error';
        submit.disabled = false;
      } finally {
        status.hidden = false;
        submitting = false;
      }
    });
  });
})();